import { ApplicationState } from "../../store/types";
import { SectionRouteHistoryState } from "./reducer";

export const getSectionRouteHistoryState = (state: ApplicationState): SectionRouteHistoryState =>
  state.sectionRouteHistory;

export const getMostRecentPaths = (state: ApplicationState) => getSectionRouteHistoryState(state).mostRecentPaths;